export default "__VITE_ASSET__6cb38197__$_?url=__"